import LanguageDetector from 'i18next-browser-languagedetector';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import moment from 'moment-timezone';
import numeral from 'numeral';

import 'moment/locale/es';
import 'moment/locale/en-gb';
import 'moment/locale/fr';
import 'moment/locale/nl';
import 'numeral/locales/es-es';
import 'numeral/locales/en-gb';
import 'numeral/locales/fr';
import 'numeral/locales/nl-nl';

import formatters from 'i18n/formatters';
import { config as defaultConfig } from './default/config';
import deepmerge from 'deepmerge';

const DEFAULT_NUMERAL_CONF = 'es-es';

// https://github.com/i18next/i18next-browser-languageDetector#detector-options
const options = {
  lookupQuerystring: 'lang',
  lookupCookie: 0,
  lookupLocalStorage: 0,
  lookupFromPathIndex: 0,
  lookupFromSubdomainIndex: 0,
  caches: [],
};

// Supported languages - add Italian and Polish
const SUPPORTED_LANGUAGES = ['es', 'en', 'fr', 'nl', 'it', 'pl', 'ro'];

const languageTonumeralLocale = (lng) => {
  const baseLanguage = lng.split('-')[0];
  const langToLocales = {
    es: 'es-es',
    en: 'en-gb',
    fr: 'fr',
    nl: 'nl-nl',
    default: DEFAULT_NUMERAL_CONF,
  };

  return baseLanguage in langToLocales
    ? langToLocales[baseLanguage]
    : langToLocales.default;
};

const createReactI18nInstance = (config) => {
  const i18n = i18next.createInstance();

  i18n.on('languageChanged', (lng) => {
    numeral.locale(languageTonumeralLocale(lng));
    moment.locale(lng);
  });
  i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
      resources: deepmerge(defaultConfig.resources, config.resources),
      fallbackLng: 'en-gb',
      ns: ['home'],
      defaultNS: 'home',
      returnEmptyString: false,
      interpolation: {
        escapeValue: false,
        format: (value, format, lng) => {
          const formatFn = formatters[format];
          return formatFn
            ? formatFn(value, format, lng)
            : formatters.default(value, format, lng);
        },
      },
      debug: false,
      react: {
        wait: true,
      },
      detection: options,
      supportedLngs: SUPPORTED_LANGUAGES,
    });

  return i18n;
};

export default createReactI18nInstance;
